import React, {useEffect, useState, useContext} from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslate } from 'react-polyglot';

import { ExplorerContext } from "../../ExplorerContext";
import InputTextField from "../../../../common/InputTextField";
import Button from "@material-ui/core/Button";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Card } from "@material-ui/core";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import FilterListIcon from '@material-ui/icons/FilterList';

import fetchHelperService from "../../../../../services/fetchHelper";

import { Scatter } from 'react-chartjs-2';
import moment from 'moment';

function CardTypeJaktprovePointsAge(props) {
    let history = useHistory();
    const t = useTranslate();

    let explorer = useContext(ExplorerContext);

    const [data, setData] = useState([]);
    const [limitedData, setLimitedData] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState([]);

    const [filterMin, setFilterMin] = useState(0);
    const [filterMax, setFilterMax] = useState(100);

    const [filteringOpen, setFilteringOpen] = useState(false);

    const [showAll, setShowAll] = useState(false);

    function fetchData() {
        if (props.onChangeStart != undefined) props.onChangeStart();
        fetchHelperService.fetchRetry("/dataapi/api/dogs/filter/carddata/jaktprovepointsage", 2000, 3, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify({
                filters: explorer.filters != undefined ? explorer.filters.filter(i => i.type != "regnumber") : [],
                type: props.examtype
            }),
        }).then(response => {
            if (response.ok && response.status === 200) return response.json();
        }).then(json => {
            setData(json.data);
            if (explorer.filters.filter(i => i.type == "jaktprovescore").length > 0) {
                let temp = json.data;
                let scoregt = explorer.filters.filter(i => i.type == "jaktprovescore" && i.operation == "gt")[0];
                let scorelt = explorer.filters.filter(i => i.type == "jaktprovescore" && i.operation == "lt")[0];
                if (scoregt != undefined) { temp = temp.filter(i => i.y > scoregt.value); }
                if (scorelt != undefined) { temp = temp.filter(i => i.y < scorelt.value); }
                setLimitedData(temp);
            }
            setAppliedFilters(JSON.parse(JSON.stringify(explorer.filters)));
            if (props.onChange != undefined) props.onChange();
        }).catch(error => console.error("Error:", error));
    }

    useEffect(() => {
        if (
            JSON.stringify(explorer.filters) != JSON.stringify(appliedFilters)
        ) {
            fetchData();
        }
    }, [explorer.filters, props.examtype]);

    return (
        <Card className="dogexplorer-card-examinationagedistribution">
            <h1>{t("dogexplorer.profile.cardtypes.huntingprovepointsage.description")}</h1>
            <div style={{ pointerEvents: "none" }}>
                <Scatter
                    chartId="barchart1-1"
                    options={{
                        tooltips: {enabled: false},
                        hover: {mode: null},
                        animation: {
                            duration: 0 // general animation time
                        },
                        responsiveAnimationDuration: 0, // animation duration after a resize
                        scales: {
                            xAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true,
                                        min: 0,
                                        max: 700,
                                        autoSkip: false,
                                        maxRotation: 52,
                                        minRotation: 25,
                                        callback: function(value, index, values) {
                                            return Math.round(value/52);
                                        }
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: t("dogexplorer.profile.cardtypes.huntingprovepointsage.currentage")
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true,
                                        max: 100
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: t("dogexplorer.profile.cardtypes.huntingprovepointsage.numberofpoints")
                                    }
                                }
                            ]
                        }
                    }}
                    data={{
                        datasets: [
                            {
                                type: "scatter",
                                backgroundColor: "#382e92",
                                label: t("dogexplorer.profile.cardtypes.huntingprovepointsage.point"),
                                pointRadius: 1,
                                data: limitedData.length != 0 ? ( !showAll ? limitedData : data) : data
                            }
                        ]
                    }}
                    maxWidth={50}
                    maxHeight={50}
                    redraw={true}
                ></Scatter>
            </div>
            <p onClick={() => setFilteringOpen(!filteringOpen)} style={{ cursor: "pointer" }}>Filter <FilterListIcon></FilterListIcon></p>
            
            <div style={ filteringOpen ? { height: "auto" } : { height: "0px", overflow: "hidden" }}>
                <InputTextField
                    inputProps={{ style: { color: "#000000" } }}
                    InputLabelProps={{ classes: { root: "registration-text" } }}
                    id="filtermin"
                    value={filterMin}
                    label={t("dogexplorer.profile.cardtypes.huntingprovepointsage.resultover")}
                    placeholder="0"
                    onChange={(evt) => setFilterMin(evt.target.value)}
                />
                <InputTextField
                    inputProps={{ style: { color: "#000000" } }}
                    InputLabelProps={{ classes: { root: "registration-text" } }}
                    id="filtermax"
                    value={filterMax}
                    label={t("dogexplorer.profile.cardtypes.huntingprovepointsage.resultunder")}
                    placeholder="0"
                    onChange={(evt) => setFilterMax(evt.target.value)}
                />
                <Button
                    style={{ width: "auto" }}
                    classes={{ root: "edit-button" }}
                    onClick={() => {
                        let filters = explorer.filters;

                        filters = filters.filter(i => i.type != "jaktprovescore");

                        if (filterMin != 0) {
                            filters.push({ type: "jaktprovescore", stage: "pre", operation: "gt", value: Number(filterMin) });
                        }
                        if (filterMax != 100) {
                            filters.push({ type: "jaktprovescore", stage: "pre", operation: "lt", value: Number(filterMax) });
                        }

                        explorer.updateFilters(filters);
                    }}
                >
                    {t("dogexplorer.profile.cardtypes.huntingprovepointsage.addfilter")}
                </Button>
                <div style={{width: "100%"}}>
                    <FormControlLabel
                        control={<Checkbox checked={Boolean(showAll)} onChange={(evt) => setShowAll(evt.target.checked)} />}
                        label={t("dogexplorer.profile.cardtypes.huntingprovepointsage.showallresults")}
                    />
                </div>
            </div>
        </Card>
    );
}

export default CardTypeJaktprovePointsAge;